exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1tvH2ib47DzFeHwNxy1tQb {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-right: 64px;\n}\n.Cn65CPoaCRcT82EpDIEBj {\n  margin-top: 30px;\n}\n._3o-YbAP4ZRsCGhMIG-WGxp {\n  font-size: 1.45rem;\n  font-weight: 500;\n  margin: 30px 0 5px 0;\n}\n.tUxhxDhZP2kMdSB0-p4lx {\n  margin: 0 0 30px 0;\n}\n", ""]);
// Exports
exports.locals = {
	"userPanel": "_1tvH2ib47DzFeHwNxy1tQb",
	"avatar": "Cn65CPoaCRcT82EpDIEBj",
	"name": "_3o-YbAP4ZRsCGhMIG-WGxp",
	"email": "tUxhxDhZP2kMdSB0-p4lx"
};